<template>
    <div id="cancel-accept-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="cancel">Отменить</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="accept">Применить</div>
    </div>
</template>

<script>
    import {bus} from "../../../vue_bus";

    export default {
        name: "RightLowerBarCropConfirmation",
        mounted() {
            bus.$emit("phe_click_crop");
        },
        destroyed() {
            bus.$emit("phe_cancel_crop");
        },
        methods: {
            accept: function () {
                bus.$emit("phe_click_apply");
                this.$router.push({name: "EditPhoto"}).catch(() => {})
            },
            cancel() {
                this.$router.push({name: "EditPhoto"}).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
